import React, { useState } from "react";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import ActiveEklokForm from "../../forms/eklok/ActiveEklokForm";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import SupportEclockOtpContainer from "../../containers/ekloks/SupportEklokOtpContainer";

const SupportEclockOtp = ({ handleClose, open, eklok }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const [activationCode, setActivationCode] = useState(null);

  return (
    <Modal
      fullScreen={matches}
      fullWidth={true}
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      title={t("active_eklok.generate_otp_code")}
    >
      {eklok ? (
        <SupportEclockOtpContainer setResult={setActivationCode}>
          {({ onSubmit }) => (
            <ActiveEklokForm
              onSubmit={onSubmit}
              initialValues={{ eklok: eklok.id }}
              activationCode={activationCode}
            />
          )}
        </SupportEclockOtpContainer>
      ) : null}
    </Modal>
  );
};

export default SupportEclockOtp;
